import { CostEstimateCard } from '@cartwheel/components'

interface Props {
  clientId: string
}

export default function CostEstimateCardMount({ clientId }: Props) {
  return <CostEstimateCard clientId={clientId} />
}
